<template>
  <b-modal v-model="showModal">
    <div slot="modal-title">
      <template v-if="$i18n.locale === 'en'">
        {{ professional.name | firstName }}{{ $t('message.professional.cleaner_reviews') }}
      </template>
      <template v-else>
        {{ $t('message.professional.cleaner_reviews') }} {{ professional.name | firstName }}
      </template>
    </div>
    <section>
      <template v-if="professionalReviews">
        <professional-reviews :professionalReviews="professionalReviews"
                              :professional="professional"
                              @changedDisplayType="onChangeDisplayType"/>
        <div class="text-center">
          <a href=""
             @click.prevent="fetchProfessionalReviews"
             class="btn btn-outline-info"
             v-if="state.isMore">{{ $t(isLoadMore) }}
          </a>
        </div>
      </template>
      <template v-else>
        <loader/>
      </template>
    </section>
    <div slot="modal-footer" class="w-100">
      <b-btn class="float-right" variant="secondary" @click="showModal = false">
        {{ $t('message.button.close') }}
      </b-btn>
    </div>
  </b-modal>
</template>

<script>
  import { mapGetters } from 'vuex'
  import Loader from '../../loader/Loader'
  import ProfessionalReviews from '../../review/ProfessionalReviews'

  export default {
    components: {
      Loader,
      ProfessionalReviews
    },
    data () {
      return {
        professional: {
          id: null,
          name: null,
          picture: null
        },
        queryData: {
          page: 0,
          professional_id: null,
          language: this.$i18n.locale,
          display_type: 'original'
        },
        showModal: false
      }
    },
    computed: {
      ...mapGetters({
        state: 'professionalReviews/getState',
        isLoadMore: 'professionalReviews/isLoadMore',
        professionalReviews: 'professionalReviews/getProfessionalReviews'
      })
    },
    methods: {
      onChangeDisplayType (displayType) {
        this.queryData.display_type = displayType
        this.queryData.page = 0
        this.queryData.limit = 5
        this.$store.dispatch('professionalReviews/SET_PROFESSIONAL_REVIEWS', null)
        this.$store.dispatch('professionalReviews/LOAD_PROFESSIONAL_REVIEWS', this.queryData)
      },
      fetchProfessionalReviews () {
        this.queryData.page++
        this.$store.dispatch('professionalReviews/LOAD_PROFESSIONAL_REVIEWS', this.queryData)
      },
      initialData () {
        this.$store.commit('professionalReviews/SET_PROFESSIONAL_REVIEWS', null)
        this.queryData.page = 0
        this.queryData.display_type = 'original'
        this.queryData.professional_id = this.professional.id
        this.$store.dispatch('professionalReviews/LOAD_PROFESSIONAL_REVIEWS', this.queryData)
        this.showModal = true
      },
      showProfessionalReviewsModal (status) {
        this.showModal = status
      },
      setProfessionalData (data) {
        this.professional.id = data.id
        this.professional.name = data.name
        this.professional.picture = data.picture
        this.initialData()
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/booking/components/CleanerReviewsModal.vue